import * as React from "react";
import BaseModal, { BaseModalContent } from "../BaseModal";
import { makeStyles } from "@material-ui/core/styles";
import '../../Pages/page.css';
import { useDispatch, useSelector } from "react-redux";
import { Button, Checkbox, FormControl, Grid, InputLabel, Select, TextField } from "@material-ui/core";
import { getAccountDriverBillingAddress, getProfileData, getStatesSelector } from "../../../store/profile/selector";
import { useFormik } from "formik";
import { profileDriverAddNewBillingAddress } from "../../../store/profile/action";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },
  additionalDetails: {
    textAlign: "left",
    fontSize: "20px",
    fontWeight: "bold",
  },
  txtLeft: {
    textAlign: "left",
    width: "100%",
  },
  textInput: {
    width: "100%",
  },
  selectBox: {
    width: "100%",
    height: 50,
  },
  btnSave: {
    paddingLeft: 50,
    paddingRight: 50,
    backgroundColor: "#20419a",
    color: "white",
  },
  btnRow: {
    textAlign: "right",
    marginTop: 20,
  },
}));

const AddBillingAdressModal = (props) => {
  const { openBillingModal, setOpenBillingModal } = props
  const cityStates = useSelector(getStatesSelector);
  const classes = useStyles();
  const profileStore = useSelector(getProfileData);
  const BillingAddress = useSelector(getAccountDriverBillingAddress)
  // const user = useSelector(getUserContextData);
  const dispatch = useDispatch();
  // React.useEffect(()=>{
  //     // dispatch(getStates(user && user.user.userName))
  //     dispatch(getStates(user && user.user.userGroup))
  // },[])

  const formik = useFormik({
    initialValues: {
      driverId: profileStore?.endUserAccountEntity?.accountId,
      defaultFlag: true,
      line1: "",
      line2: "",
      city: "",
      state: "",
      // state: {
      //   code: "",
      // },
      zip: "",
    },
    onSubmit: (values) => {
      dispatch(profileDriverAddNewBillingAddress({ values }))
      // alert(JSON.stringify(values, null, 2));
      setOpenBillingModal(false)
    },
  });

  const handleSelect = (e) => {
    formik.setFieldValue("state", e.target.value);
  };
  const handleCheckbox = (e) => {
    formik.setFieldValue("defaultFlag", e.target.checked);
  };

  const handleClose = () => {
    setOpenBillingModal(false)
  }

  const disablefun = () => {
    if(formik.values.line1 !== "" && formik.values.state !== "Choose ..." && formik.values.city !== "" && formik.values.zip !== ""){
      return false
    }else{
      return true
    }
  }

  return (
    <>
      <BaseModal
        title="Driver Account Billing Address"
        align="center"
        open={openBillingModal}
        onClose={handleClose}
        fullWidth
        className="modal-header"
      >
        <BaseModalContent>
          <form onSubmit={formik.handleSubmit} className="dAdd">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <InputLabel htmlFor="outlined-make" className={classes.vin}>
                  Address *
                </InputLabel>
                <TextField
                  level="Address *"
                  type={"text"}
                  id="line1"
                  name="line1"
                  onChange={formik.handleChange}
                  value={formik && formik.values.line1}
                  className={classes.textInput}
                  helperText="1234 Generic Lane"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  level="Address2 "
                  type={"text"}
                  // value={formik && formik.line2}
                  id="line2"
                  name="line2"
                  onChange={formik.handleChange}
                  value={formik && formik.values.line2}
                  className={classes.textInput}
                  helperText="Apt C Unit#104"
                />
              </Grid>
              <Grid item xs={12}>
                <InputLabel htmlFor="outlined-make" className={classes.vin}>
                  City *
                </InputLabel>
                <TextField
                  level="City *"
                  type={"text"}
                  name="city"
                  onChange={formik.handleChange}
                  value={formik && formik.values.city}
                  className={classes.textInput}
                />
              </Grid>
              <Grid item xs={12} sm={12} xxl={6} xl={6} lg={6} md={6} >
                <FormControl variant="outlined" style={{ width: "100%" }}>
                  <InputLabel htmlFor="outlined-state">Select State *</InputLabel>
                  <Select
                    native
                    // onChange={formik.handleChange}
                    onChange={handleSelect}
                    value={formik.values.state || "Choose ..."}
                    label="Select State "
                    id="code"
                    name="code"
                    className={classes.selectBox}
                    displayEmpty
                  >
                    <option>Choose ...</option>
                    {cityStates &&
                      cityStates.map((element) => (
                        <option key={`${element.name}-${element.code}`} value={element.code} disabled={!element.code}>
                          {element.name}
                        </option>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} xxl={6} xl={6} lg={6} md={6} >
                <InputLabel htmlFor="outlined-make" className="vin">
                  Zip Code *
                </InputLabel>
                <TextField
                  level="Zip Code *"
                  type={"text"}
                  name="zip"
                  id="zip"
                  maxlength={10}
                  onChange={formik.handleChange}
                  value={formik.values.zip}
                  className={classes.textInput}
                />
              </Grid>
              <Grid item xs={12} >
                <div className="d-flex align-items-center">
                  <Checkbox
                    name="defaultFlag"
                    checked={formik.values.defaultFlag}
                    // className={classes.textInput}
                    color="primary"
                    id="outlined-make"
                    onChange={handleCheckbox}
                  />
                  <InputLabel htmlFor="outlined-make" className="vin">
                    Set The Default Address{" "}
                  </InputLabel>

                </div>
              </Grid>

              <Grid item xs={12}>
                <div className='d-flex justify-content-between align-items-center'>
                  <Button onClick={handleClose} className="mr-2">Cancel</Button>
                  <Button
                    variant="contained"
                    type="submit"
                    className={classes.btnSave}
                    disabled={ disablefun()}
                  >
                    Save
                  </Button>
                </div>
              </Grid>
            </Grid>

          </form>
        </BaseModalContent>
      </BaseModal>
    </>
  )
}
export default AddBillingAdressModal;